import { CommonModule } from '@angular/common';
import { Component, Input, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../../material.module';
import { Routes } from "@angular/router";
import { EventEmitter } from '@angular/core';
import { NotesofaccountsComponent } from '../notesofaccounts.component';

@Component({
  selector: 'app-note4',
  imports: [TablerIconsModule, MaterialModule, CommonModule, RouterModule, MatTabsModule, NotesofaccountsComponent],
  templateUrl: './note4.component.html',
  styleUrl: './note4.component.scss'
})
export class Note4Component {


  constructor(private router: Router, private ParentCoponent: NotesofaccountsComponent) {
    alert('child')
  }
  ngOnInit(): void {
    alert('ngonit')
    this.SaveandNextNote(this.selectedNoteFromParent, false)
  }
  selectNotes: boolean = true; selectedNotes: boolean = false;

  CurrentNote: string;
  CurrentNoteisactive: string;

  note18: boolean = false; isActive18: boolean = false; note19: boolean = false; isActive19: boolean = false;

  @Output() childClicked = new EventEmitter<string>(); // Emits a string
  @Input() selectedNoteFromParent: string; // This receives data from the parent
  emitClickEvent(CurrentNote: any) {
    this.childClicked.emit(CurrentNote);
  }

  displayedColumns: string[] = ['id', 'Description', 'year'];
  data: any[] = [
    { type: 'Government grant 1', Description: '', Year: ''},
    { type: 'Government grant 2', Description: '', Year: ''},
    { type: 'Government grant 3', Description: '', Year: ''},
    { type: 'Other', Description: '', Year: ''},
  ];

  displayedColumns2: string[] = ['id', 'Description', 'year'];
  data2: any[] = [
    { type: 'Government grant 1', Description: '', Year: '' },
    { type: 'Government grant 2', Description: '', Year: '' },
    { type: 'Government grant 3', Description: '', Year: '' },
    { type: 'Other', Description: '', Year: '' },
  ];

  displayedColumns3: string[] = ['id', 'thisYear', 'LastYear'];
  data3: any[] = [
    { type: 'Please provide details of any unfulfilled conditions and other contingencies attaching to grants that have been recognised in income.', Description: '', Year: '' },
  ];

  displayedColumns4: string[] = ['id', 'thisYear', 'LastYear'];
  data4: any[] = [
    { type: 'Please give details of other forms of government assistance from which the charity has directly benefited.', Description: '', Year: '' },
  ];

  note5displayedColumns: string[] = ['id', 'thisYear', 'lastYear'];
  note5data: any[] = [
    { type: 'Seconded staff', Description: '', Year: '' },
    { type: 'Use of property', Description: '', Year: '' },
    { type: 'Other', Description: '', Year: '' },
  ];

  note5displayedColumns2: string[] = ['id', 'thisYear', 'LastYear'];
  note5data2: any[] = [
    { type: 'Please provide details of the accounting policy for the recognition and valuation of donated goods, facilities and services.', Description: '', Year: '' },
  ];

  note5displayedColumns3: string[] = ['id', 'thisYear', 'LastYear'];
  note5data3: any[] = [
    { type: 'Please provide details of any unfulfilled conditions and other contingencies attaching to resources from donated goods and services not recognised in income.', Description: '', Year: '' },
  ];

  note5displayedColumns4: string[] = ['id', 'thisYear', 'LastYear'];
  note5data4: any[] = [
    { type: 'Please give details of other forms of other donated goods and services not recognised in the accounts, eg contribution of unpaid volunteers.', Description: '', Year: '' },
  ];

  BackNote() {
    debugger
    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber = ''
    currentNoteNumber = this.CurrentNote.split('note')[1]
    currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

    NextNoteisactive = `isActive${+currentNoteisactive - 1}`
    NextNoteNumvber = `note${+currentNoteNumber - 1}`
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)
  }
  SaveandNextNote(note?: any, IsNextClick?: any) {
    debugger

    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber = ''
    if (IsNextClick == false) {
      var Parentnote = this.selectedNoteFromParent.split('/')
      currentNoteNumber = Parentnote[0].split('note')[1]
      currentNoteisactive = Parentnote[1].split('isActive')[1]
      NextNoteNumvber = `note${+currentNoteNumber}`

      this.CurrentNote = NextNoteNumvber
      NextNoteisactive = `isActive${+currentNoteisactive}`
    }
    else {

      currentNoteNumber = this.CurrentNote ? this.CurrentNote.split('note')[1] : note.split('note')[1]
      currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

      NextNoteisactive = `isActive${+currentNoteisactive + 1}`
      NextNoteNumvber = `note${+currentNoteNumber + 1}`
    }
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)

  }

  ClickSelectedNote(note: string, IsActive?: any): void {
    debugger
    this.note18 = false;
    this.isActive18 = false;
    (this as any)[note] = true;

    // this.emitClickEvent(this.CurrentNote)
    this.CurrentNoteisactive = IsActive
    this.CurrentNote = note


  }

  SaveAndNext() {
    debugger
    var currentNoteNumber = this.CurrentNote.split('note')[1]
    // var currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]
    var NextNoteNumvber = `note${+currentNoteNumber + 1}`
    // var NextNoteisactive = `isActive${+currentNoteisactive + 1}`
    //   this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    // this.router.navigate([''])
  }
}

